exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{height:100%;overflow:hidden;background:#000;font-family:sans-serif;margin:0;user-select:none}#_1CCTK0YbLr2WqPWS0lRbFS{height:100%;margin:0 auto;text-align:center;position:relative}.Zmm2sLTVh372dEHLHv3TM{position:absolute;left:0;right:0;height:100%;background:#333;overflow:hidden}", ""]);

// exports
exports.locals = {
	"wrap": "_1CCTK0YbLr2WqPWS0lRbFS",
	"wrap": "_1CCTK0YbLr2WqPWS0lRbFS",
	"overlay": "Zmm2sLTVh372dEHLHv3TM",
	"overlay": "Zmm2sLTVh372dEHLHv3TM"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&camelCase!./~/postcss-loader!./src/styles/App.css
// module id = 476
// module chunks = 0